module.exports = __webpack_public_path__ + "app/prepasrel/edit-workflow-ycQosibF.html";